import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/DeniseMcKay_Pet/subs.vtt';
import poster from '@/static/assets/reviews/DeniseMcKay_Pet/video.jpg';

export const DeniseMcKay: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet],
  reviewerName: 'Denise',
  videoUrl: `${ASSETS_URL}/pet/Denise_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
